"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// A (possibly faster) way to get the current timestamp as an integer.
var _default = Date.now || function () {
  return new Date().getTime();
};

exports.default = _default;